/**
 * @author       denys.yefremov@startupsoft.co (Denys Yefremov)
 * @copyright    Copyright (c) 2022, Zumper
 */

import type { School, SchoolDistrict, SchoolLevelsWidget, State } from '@zcode/state-type'
import { compose } from 'redux'

export const selectSchoolWidget = (state: State) => state.schoolWidget

export const selectSchoolWidgetLevel = compose(
  (schoolWidget) =>
    schoolWidget.schoolDistrictLevels as {
      [Key in SchoolLevelsWidget]?: School[]
    },
  selectSchoolWidget
)

export const selectSelectedDistrictId = compose(
  (schoolWidget) => schoolWidget.selectedDistrictId,
  selectSchoolWidget
)

export const selectSchoolDistricts = compose(
  (schoolWidget) => schoolWidget.schoolDistricts,
  selectSchoolWidget
)

export const selectSelectedDistrict = (state: State) => {
  const schoolDistrictsData = selectSchoolDistricts(state)
  const selectedDistrictId = selectSelectedDistrictId(state)
  return schoolDistrictsData.find(
    (district: SchoolDistrict) => district.districtId === selectedDistrictId
  )
}

export const selectSelectedSchoolLevel = compose(
  (schoolWidget) => schoolWidget.selectedSchoolLevel,
  selectSchoolWidget
)

export const selectSchoolsCount = (state: State) => {
  const district = selectSelectedDistrict(state)
  const schoolLevel = selectSelectedSchoolLevel(state)
  return district?.[`${schoolLevel}Count`]
}

export const selectDistrictMeta = compose(
  (schoolWidget) => schoolWidget.districtMeta,
  selectSchoolWidget
)

export const selectDistrictsFetching = compose(
  (meta) => meta?.fetching || false,
  selectDistrictMeta
)

export const selectDistrictsFetcingError = compose((meta) => meta?.error, selectDistrictMeta)

export const selectSchoolsMeta = compose(
  (schoolWidget) => schoolWidget.schoolsMeta,
  selectSchoolWidget
)

export const selectSchoolsFetching = compose((meta) => meta?.fetching || false, selectSchoolsMeta)

export const selectSchoolsFetcingError = compose((meta) => meta?.error, selectSchoolsMeta)
